import { AfterContentInit, Component, Injector } from '@angular/core';
import { BasePageComponent } from '../../../base/components/base-page.component';
import { ApplicationUserModel } from '../../models/application-user.model';
import { UsersService } from '../../services/users.service';
import { AuthService } from '../../../core/auth/auth.service';
import { UserPrimaryRoleConstants } from '../../constants/roles.constants';
import { AppIdConstants } from '../../constants/appId.constants';
import { ClientAccountService } from '../../services/client-account.service';

@Component({
  selector: 'app-user-choice',
  templateUrl: './user-choice.component.html',
  styleUrls: ['./user-choice.component.scss']
})
export class UserChoiceComponent extends BasePageComponent implements AfterContentInit {
  users: Array<ApplicationUserModel>;

  UserPrimaryRoleConstants = UserPrimaryRoleConstants;
  AppIdConstants = AppIdConstants;

  constructor(injector: Injector, private usersService: UsersService, private authService: AuthService, private clientAccountService: ClientAccountService) {
    super(injector);
    this.startPageLoading();
    this.clientAccountService.clearUnit(true);
    this.usersService.clearUser();
    this.storageService.deletePreference('features');
  }

  ngAfterContentInit(): void {
  }

  ngOnDestroyForChildren(): void {
  }

  ngOnInitForChildren(): void {
    this.usersService.getUsers().subscribe((res: Array<ApplicationUserModel>) => {
      if (res.length === 0) {
        this.router.navigate(['error-unauthorized']);
      }
      this.users = res;
      console.log(this.users);
      this.stopPageLoading();
    });
  }

  selectUser(user, ag) {
    const selectedUser = user;
    var selectedAggregation = user.aggregations.filter((us) => {
      return us.unit === ag;
    });

    selectedUser.aggregations = selectedAggregation;

    if (this.usersService.isCallCenterUser()) {
      this.clientAccountService.setCustomer(null);
      this.clientAccountService.setAccount(null);
      this.router.navigate(['dashboard']);
      return;
    }
    this.usersService.setUser(selectedUser);
    this.router.navigate(['client-account-choice']);
  }

  logout() {
    this.authService.logout();
  }

  pageName(): string {
    return 'UserChoiceComponent';
  }
}
